import momentTz from 'moment-timezone';

export function recurringDates(pattern) {
  let { start, end, timeZone, interval, frequency, exceptions } = pattern;
  // console.info('recurringDates', pattern);

  exceptions = exceptions && exceptions.length ? exceptions : null;

  let endMoment = momentTz.tz(end.toISOString(), timeZone).endOf('day');
  end = endMoment.toDate();

  switch (frequency) {
    case 'd':
      // console.log('daily repeat', start, interval);
      return daily(start, end, timeZone, interval, exceptions);
      break;
    case 'w':
      // console.log('weekly repeat', start, interval);
      return weekly(start, end, timeZone, interval, exceptions);
      break;
    case 'm':
      // console.log('monthly repeat', start, interval);
      return monthly(start, end, timeZone, interval, exceptions);
      break;
    case 'y':
      // console.log('yearly repeat', start, interval);
      return yearly(start, end, timeZone, interval, exceptions);
      break;
  }
}

function daily(start, end, timeZone, interval, exceptions) {
  // console.info('daily', start, end, timeZone, exceptions);

  let currentExceptionIndex = 0;
  let currentException;
  if (exceptions) currentException = new Date(exceptions[currentExceptionIndex]);

  let startMillis = start.getTime();
  let oneDay = 1000 * 24 * 60 * 60;
  let numDays = parseInt((end.getTime() - startMillis) / oneDay);
  let recurring = [];

  let startMoment = momentTz.tz(start.toISOString(), timeZone);

  for (let i = 0; i <= numDays; i++) {
    if (i > 0) startMoment.add(1, 'd');
    let nextDate = startMoment.toDate();

    if (currentException && currentException.getTime() === nextDate.getTime()) {
      if (++currentExceptionIndex < exceptions.length) {
        currentException = new Date(exceptions[currentExceptionIndex]);
      } else {
        currentException = null;
      }
      continue;
    }
    recurring.push(nextDate);
  }
  // console.log('daily returning ', recurring);
  // console.log('1', recurring.slice(100));
  // console.log('2', recurring.slice(200));
  // console.log('3', recurring.slice(300));
  return recurring;
}

function weekly(start, end, timeZone, interval, exceptions) {
  // console.info('weekly', start, end, timeZone);

  let currentExceptionIndex = 0;
  let currentException;
  if (exceptions) currentException = new Date(exceptions[currentExceptionIndex]);

  interval = interval || 1;
  let startMillis = start.getTime();
  let intervalMillis = 1000 * 24 * 60 * 60 * 7 * interval;
  let numDays = parseInt((end.getTime() - startMillis) / intervalMillis);
  let recurring = [];

  let startMoment = momentTz.tz(start.toISOString(), timeZone);

  for (let i = 0; i <= numDays; i++) {
    if (i > 0) startMoment.add(interval, 'w');
    let nextDate = startMoment.toDate();

    if (currentException && currentException.getTime() === nextDate.getTime()) {
      if (++currentExceptionIndex < exceptions.length) {
        currentException = new Date(exceptions[currentExceptionIndex]);
      } else {
        currentException = null;
      }
      continue;
    }

    recurring.push(nextDate);
  }
  // console.info('weekly returning ', recurring);
  return recurring;
}

function yearly(start, end, timeZone, interval, exceptions) {
  // console.info('yearly', start, timeZone, exceptions);

  let currentExceptionIndex = 0;
  let currentException;
  if (exceptions) currentException = new Date(exceptions[currentExceptionIndex]);

  let startMillis = start.getTime();
  let oneYear = 1000 * 24 * 60 * 60 * 365;
  let numDays = parseInt((end.getTime() - startMillis) / oneYear) + 1;
  let recurring = [];

  let startMoment = momentTz.tz(start.toISOString(), timeZone);

  for (let i = 0; i <= numDays; i++) {
    if (i > 0) startMoment.add(1, 'y');
    let nextDate = startMoment.toDate();

    if (nextDate.getMonth() !== start.getMonth()) {
      // was a leap year issue
      nextDate.setMonth(start.getMonth());
      nextDate.setDate(28);
    }

    if (currentException && currentException.getTime() === nextDate.getTime()) {
      if (++currentExceptionIndex < exceptions.length) {
        currentException = new Date(exceptions[currentExceptionIndex]);
      } else {
        currentException = null;
      }
      continue;
    }

    recurring.push(nextDate);
  }
  // console.info('yearling returing: ', recurring);
  return recurring;
}

function monthly(start, end, timeZone, interval, exceptions) {
  // console.info('monthly', start, timeZone, exceptions);

  let currentExceptionIndex = 0;
  let currentException;
  if (exceptions) currentException = new Date(exceptions[currentExceptionIndex]);

  let startMillis = start.getTime();
  let oneMonth = 1000 * 24 * 60 * 60 * 30;
  let numDays = parseInt((end.getTime() - startMillis) / oneMonth) + 1;
  let recurring = [];

  let startMoment = momentTz.tz(start.toISOString(), timeZone);

  for (let i = 0; i <= numDays; i++) {
    if (i > 0) startMoment.add(1, 'M');
    let nextDate = startMoment.toDate();

    let nextMonth = new Date(start).getMonth() + i;
    let monthAdjusted = nextMonth % 12;

    if (nextDate.getMonth() !== monthAdjusted) {
      // was a leap year issue
      nextDate.setMonth(monthAdjusted);
      if (monthAdjusted == 1) {
        let nextYear = nextDate.getFullYear();
        let dayNum = 28;
        if (nextYear % 4 == 0 && (nextYear % 100 != 0 || nextYear % 400 == 0)) {
          dayNum = 29;
        }
        nextDate.setDate(dayNum);
      } else nextDate.setDate(30);
    }

    if (currentException && currentException.getTime() === nextDate.getTime()) {
      if (++currentExceptionIndex < exceptions.length) {
        currentException = new Date(exceptions[currentExceptionIndex]);
      } else {
        currentException = null;
      }
      continue;
    }

    recurring.push(nextDate);
  }
  // console.info('monthly returning ', recurring);
  return recurring;
}
